import Proxy from '../Proxy';

class FormPhoneProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('form-phones', parameters);
  }
}

export default FormPhoneProxy;
